import * as CoreFns from '../utilities/CoreFns';
import * as StyleFunctions from '../utilities/StyleFunctions';
import * as EditorFunctions from '../utilities/EditorFunctions';
import TextBoxIcons from '../StockItems/TextBoxIcons';

function App(props) {

  var currentList = props.currentList;
  var error = props.error;
  var itemEdited = props.itemEdited;
  var setItemEdited = props.setItemEdited;
  var highlightAnItem = props.highlightAnItem;
  var isShowingSomeDropDown = props.isShowingSomeDropDown;
  var whereFrom = props.whereFrom;

  var name = '';
  var pathDown = itemEdited.path;
  var f;


  function editPanel(){
    if (pathDown[0] === 'fo'){
      setItemEdited({t:'screen', path:CoreFns.filterPathStopBefore(pathDown, 1)})
    }else{
      setItemEdited({t:'screen', path:CoreFns.filterPathStopBefore(pathDown, 4)})
    }
  }        

  if (!itemEdited){
  }else if (itemEdited.t === 'item'){
    var thisItem;
    try{
      thisItem = CoreFns.goDownPath(currentList, pathDown);
    }catch(err){

    }

    if (thisItem){

      var itemScreenPath1 = pathDown.filter((aP,index)=>{
        return +index < pathDown.length - 2;
      })

      var parentItem = CoreFns.goDownPath(currentList, itemScreenPath1);

      function editCard(){
        setItemEdited({t:'item', path:itemScreenPath1})        
      }        

      if (EditorFunctions.isNavPath(itemEdited.path)){ //navbarItem
      }else if (StyleFunctions.isFirstLevel(pathDown)){
        if (pathDown[0] === 'fo'){
          name = 'Footer';
          f = editPanel;
        }else{
          name = 'Panel';
          f = editPanel;
        }
      }else{
        name = CoreFns.getElementInfo(parentItem.t).t;
        f = editCard;
      }


    }
  }else if (itemEdited.t === 'screen' || itemEdited.t === 'navBar'){
    function editPage(e){
      setItemEdited({t:'page', path:CoreFns.filterPathStopBefore(pathDown, 2)})
    }
    f = editPage;
    name = 'Page';
  }else if (itemEdited.t === 'asset' ){
  }else if (itemEdited.t === 'alert'){
    f = editPanel;
    name = 'Panel';
  }else if (itemEdited.t === 'page' && whereFrom === 'add'){
    name = 'Overall';
    function editNone(){
      setItemEdited(false)        
    }        
    f = editNone;
  }

  var upperPiece;
  if (name){
    upperPiece = <TextBoxIcons anItem={{t:'Amend Parent ('+name+')',a:0,f, i:'carbon:folder-parent'}} isShowingSomeDropDown={isShowingSomeDropDown} error={error} itemEdited={itemEdited} highlightAnItem={highlightAnItem}/>        
  }


   return <div className='col-6'>{upperPiece}</div>

}

export default App;
